module.exports = __webpack_public_path__ + "img/icon-mn3.35941bff.png";